export class GenerateValidateEmailParameterDto {
  email: string;
  recaptchaToken: string;
}
